import { useCallback } from 'react';
import { ReactComponent as HeartIcon } from '../assets/heart.svg';
import { useGameStore } from '../hooks/useGameStore';

export function Life() {
  const life = useGameStore(useCallback((state) => state.life, []));

  return (
    <div className="flex flex-row space-x-4">
      <Heart full={life > 2} />
      <Heart full={life > 1} />
      <Heart full={life > 0} />
    </div>
  );
}

function Heart({ full }: { full: boolean }) {
  return (
    <div className="relative w-8 h-8">
      <div className="absolute fill inset-0">
        <HeartIcon className="absolute fill inset-0" />
      </div>
      <div
        className={`absolute fill inset-0 transition-transform transform ${
          full ? 'scale-100' : 'scale-0'
        }`}
        style={{ '--heart-fill': 'var(--secondary-dark-color)' } as any}
      >
        <HeartIcon />
      </div>
    </div>
  );
}
